import { useRef, useState } from "react";
import { Loader2, Upload, X } from "lucide-react";
import { toast } from "sonner";
import { formatError, mediaUrl, uploadFile } from "@/lib/api";

export const UploadButton = ({ accept = "image/*", multiple, onUploaded, label = "Enviar arquivo", testid }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    const urls = [];
    for (const f of files) {
      try {
        urls.push(await uploadFile(f));
      } catch (err) {
        toast.error(`${f.name}: ${formatError(err)}`);
      }
    }
    setBusy(false);
    if (urls.length) {
      onUploaded(urls);
      toast.success(urls.length > 1 ? `${urls.length} arquivos enviados` : "Arquivo enviado");
    }
  };
  return (
    <>
      <input ref={ref} type="file" accept={accept} multiple={multiple} className="hidden" onChange={pick} data-testid={`${testid}-input`} />
      <button type="button" disabled={busy} onClick={() => ref.current?.click()} className="inline-flex items-center gap-2 h-10 px-4 text-xs uppercase tracking-[0.15em] border border-[#C5A059]/60 text-[#E5CF9F] hover:bg-[#C5A059] hover:text-[#08080A] transition-colors disabled:opacity-60" data-testid={testid}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} {busy ? "Enviando..." : label}
      </button>
    </>
  );
};

export const MediaInput = ({ label, value, onChange, kind = "image", testid, help }) => (
  <div>
    <span className="block text-[0.68rem] uppercase tracking-[0.18em] text-[#A1A1AA] mb-2">{label}</span>
    <div className="flex flex-col sm:flex-row gap-4">
      <div className="relative w-full sm:w-56 aspect-video bg-[#0F0F12] border border-white/10 overflow-hidden shrink-0" data-testid={`${testid}-preview`}>
        {value ? (
          kind === "video" ? (
            <video key={value} src={mediaUrl(value)} muted autoPlay loop playsInline controls className="h-full w-full object-cover" />
          ) : (
            <img src={mediaUrl(value)} alt="" className="h-full w-full object-cover" />
          )
        ) : (
          <span className="absolute inset-0 flex items-center justify-center text-xs text-[#71717A]">Nenhum arquivo</span>
        )}
      </div>
      <div className="flex-1 space-y-3">
        <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="https://... ou envie um arquivo" className="w-full h-11 bg-[#0F0F12] border border-white/10 focus:border-[#C5A059]/70 outline-none text-sm text-white px-3" data-testid={`${testid}-url-input`} />
        <div className="flex flex-wrap gap-2">
          <UploadButton accept={kind === "video" ? "video/mp4,video/webm,video/quicktime" : "image/*"} onUploaded={(u) => onChange(u[0])} label={kind === "video" ? "Enviar vídeo" : "Enviar imagem"} testid={`${testid}-upload`} />
          {value && (
            <button type="button" onClick={() => onChange("")} className="inline-flex items-center gap-2 h-10 px-4 text-xs uppercase tracking-[0.15em] border border-white/10 text-[#A1A1AA] hover:text-white" data-testid={`${testid}-clear`}>
              <X className="w-4 h-4" /> Remover
            </button>
          )}
        </div>
        {help && <p className="text-xs text-[#71717A]">{help}</p>}
      </div>
    </div>
  </div>
);
